import React, { useCallback, useEffect, useLayoutEffect, useMemo, useState } from 'react';
// import { useParams } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux';
import {
  Button,
  Card,
  CardContent,
  Table,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  styled,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import Select from 'react-select';

import TablePaginator from '../../../../components/tableComponents/TablePaginator/TablePaginator';
import { SHeadTableCell } from '../../../../components/styledComponents/Tables';
import AlertDialog from '../../../../components/other/Dialog/AlertDialog';
import Preloader from '../../../../components/other/Preloader/Preloader';
import { IAppState } from '../../../../store/rootDuck';
import { actions as orderActions } from '../../../../store/ducks/orders.duck';
import { actions as messsageActions } from '../../../../store/ducks/messages.duck';
import { getOrderTypeWithTranslates, ListType } from '../constatns';
import { IUser, UserRoles } from '../../../../interfaces/user';
import MessagesDialog from '../MessagesDialog';
import { IOrder, IOrderResponse } from '../../../../interfaces/order';
import { actions as profileActions } from '../../../../store/ducks/profile.duck';
import { actions as companiesActions } from '../../../../store/ducks/companies.duck';
import { useStyles } from '../hooks/useStyles';
import { useDefineUserRole, useFormatMessage } from '../../../../hooks';
import TableRowOrderList from './TableRowOrderList';
import { useSearchUsers } from '../../users/users/hooks/useSearchUsers';
import AutocompleteStaffPhone from '../../../../components/AutocompleteStaffPhone';
import { useGetOrders } from '../hooks/useGetOrders';

const StyledButton = styled(Button)({
  width: '150px',
  height: '30px',
  borderRadius: '10px',
  backgroundColor: '#b8bfbe',
  color: '#000000', // Цвет текста - черный
  fontFamily: 'inherit', // Используем шрифт по умолчанию
  textTransform: 'none', // Отключаем преобразование текста в заглавные буквы
  boxShadow: 'none', // Убираем тень
  '&:hover': {
    backgroundColor: '#a9b0af', // Немного темнее при наведении
    boxShadow: 'none', // Убираем тень и при наведении
  },
});

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.locale('ru');

// const getStatusString = (type: string, selectedType?: string, me?: IUser): string => {
//   switch (type) {
//     case ListType.FULL:
//       if (me?.roles.includes(UserRoles.ROLE_BUYER)) {
//         return `${
//           selectedType
//             ? `${selectedType}`
//             : orderTypeList.filter(item => item !== 'completed').toString()
//         }`;
//       }
//       return `${selectedType ? `${selectedType}` : orderTypeList.toString()}`;
//     case ListType.ABANDONED:
//       return 'cart';
//     default:
//       return `[]`;
//   }
// };

const getTomorrow = (): Date => {
  const today = new Date();
  today.setDate(today.getDate() + 1);
  return today;
};

const getYesterday = (activeTab?: 'active' | 'completed' | 'all'): Date => {
  const today = new Date();
  today.setDate(today.getDate() - (activeTab === 'active' ? 1 : 10));
  return today;
};

const OrdersList: React.FC<
  TPropsFromRedux & {
    type: string;
    userId?: number;
    smallSendMsgBtn?: boolean;
    activeTab?: 'active' | 'completed' | 'all';
  }
> = ({
  delError,
  clearErrors,
  userRole,
  clearMessages,
  meLoading,
  fetchMe,
  clearMe,
  me,
  type,
  userId,
  fetchCompanies,
  activeTab = 'all',
  // smallSendMsgBtn,
}) => {
  const { classes } = useStyles();
  const intl = useIntl();
  const fm = useFormatMessage();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [deleteId, setDeleteId] = useState<number | undefined>(-1);
  const [isAlertOpen, setAlertOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(-1);
  const [showModalMessages, setShowModalMessages] = useState(false);
  const [currentResponse, setCurrentResponse] = useState<IOrder | null>(null);
  // const [createChatFetch, loadingCreated, createChat] = useCreateChat();
  const defaultType = { value: '', label: fm('ORDER.FILTER.PLACEHOLDER') };
  const isCreateOrder = useDefineUserRole(me, [
    'ROLE_MANAGER',
    'ROLE_ADMIN',
    'ROLE_ORDER_OPERATOR',
  ]);
  // const [paymentType, setPaymentType] = useState<string>('');

  const [startDate, setStartDate] = useState<Date | null>(getYesterday(activeTab));
  const [endDate, setEndDate] = useState<Date | null>(getTomorrow());

  const [selectedOrderId, setSelectedOrderId] = useState<string>('');
  const [selectedOrderStatus, setSelectedOrderStatus] = useState<string>('');

  const [selectedDriverPhone, setSelectedDriverPhone] = useState<string | null>(null);
  const [selectedDriverUser, setSelectedDriverUser] = useState<IUser>({} as IUser);
  const [driverSearchUsers, setDriverSearchUsers] = useState<IUser[]>([]);
  const [loadingDriverPhone, setLoadingDriverPhone] = useState(false);

  const [selectedClientPhone, setSelectedClientPhone] = useState<string | null>(null);
  const [selectedClientUser, setSelectedClientUser] = useState<IUser>({} as IUser);
  const [clientSearchUsers, setClientSearchUsers] = useState<IUser[]>([]);
  const [loadingClientPhone, setLoadingClientPhone] = useState(false);
  const [autoUpdate, setAutoUpdate] = useState(localStorage.getItem('autoUpdate') === 'true');

  const {
    fetch,
    loading,
    orders,
    page: { page, total },
    perPage,
    setPerPage,
    updateOrders,
    editLoading,
    editSuccess,
    editStatus,
    delOrder,
  } = useGetOrders(() => {
    setSelectedOrderId('');
    setSelectedDriverPhone(null);
    setSelectedClientPhone(null);
    setSelectedDriverUser({} as IUser);
    setSelectedClientUser({} as IUser);
    setDriverSearchUsers([]);
    setClientSearchUsers([]);
    setDriverSearchUsersFromApi([]);
    setClientSearchUsersFromApi([]);
  });

  const {
    fetchUsers: fetchDriverUsersApi,
    loadingPhone: loadingDriverPhoneApi,
    users: driverSearchUsersFromApi,
    setUsers: setDriverSearchUsersFromApi,
  } = useSearchUsers();

  const {
    fetchUsers: fetchClientUsersApi,
    loadingPhone: loadingClientPhoneApi,
    users: clientSearchUsersFromApi,
    setUsers: setClientSearchUsersFromApi,
  } = useSearchUsers();

  const fetchDriverUsers = useCallback(
    async (params: any) => {
      await fetchDriverUsersApi({ ...params, roles: 'ROLE_VENDOR' });
    },
    [fetchDriverUsersApi]
  );

  const fetchClientUsers = useCallback(
    async (params: any) => {
      await fetchClientUsersApi({ ...params, roles: 'ROLE_BUYER' });
    },
    [fetchClientUsersApi]
  );

  useEffect(() => {
    setStartDate(getYesterday(activeTab));
  }, [activeTab]);

  useEffect(() => {
    setDriverSearchUsers(driverSearchUsersFromApi);
  }, [driverSearchUsersFromApi]);

  useEffect(() => {
    setClientSearchUsers(clientSearchUsersFromApi);
  }, [clientSearchUsersFromApi]);

  useEffect(() => {
    setLoadingDriverPhone(loadingDriverPhoneApi);
  }, [loadingDriverPhoneApi]);

  useEffect(() => {
    setLoadingClientPhone(loadingClientPhoneApi);
  }, [loadingClientPhoneApi]);

  const getStatusesForTab = useCallback(() => {
    if (type === ListType.ABANDONED) {
      return 'formed';
    }
    if (activeTab === 'active') {
      return 'new,driver_found,driver_coming,driver_waiting,way';
    }
    if (activeTab === 'completed') {
      return 'completed,canceled';
    }
    return 'new,driver_found,driver_coming,driver_waiting,way,completed,canceled';
  }, [activeTab, type]);

  const getAvailableStatusesForSelect = useCallback(() => {
    if (activeTab === 'active') {
      return ['new', 'driver_found', 'driver_coming', 'driver_waiting', 'way'];
    }
    if (activeTab === 'completed') {
      return ['completed', 'canceled'];
    }
    return [
      'new',
      'driver_found',
      'driver_coming',
      'driver_waiting',
      'way',
      'completed',
      'canceled',
    ];
  }, [activeTab]);

  useEffect(() => {
    setSelectedOrderStatus('');
  }, [activeTab]);

  useEffect(() => {
    const statuses = selectedOrderStatus || getStatusesForTab();
    // const userPhone = selectedDriverPhone || selectedClientPhone || undefined;
    const orderId =
      selectedOrderId && selectedOrderId.trim() !== ''
        ? parseInt(selectedOrderId.trim(), 10)
        : undefined;

    fetch({
      statuses,
      page: 1,
      perPage,
      userId: selectedClientUser.id,
      driverId: selectedDriverUser.id,
      date_from: startDate ? moment(startDate).format('YYYY-MM-DD') : undefined,
      date_to: endDate ? moment(endDate).format('YYYY-MM-DD') : undefined,
      id: orderId && !Number.isNaN(orderId) ? orderId : undefined,
    });
  }, [
    type,
    userId,
    activeTab,
    getStatusesForTab,
    me,
    startDate,
    endDate,
    selectedDriverUser,
    selectedClientUser,
    selectedOrderId,
    selectedOrderStatus,
    editSuccess,
  ]);

  useEffect(() => {
    const intervel = setInterval(() => {
      if (activeTab === 'active' && !loading && me && autoUpdate) {
        const statuses = selectedOrderStatus || getStatusesForTab();
        updateOrders({
          statuses,
          page: 1,
          perPage,
          date_from: startDate ? moment(startDate).format('YYYY-MM-DD') : undefined,
          date_to: endDate ? moment(endDate).format('YYYY-MM-DD') : undefined,
        });
      }
    }, 15000);

    if (!autoUpdate && intervel) {
      clearInterval(intervel);
    }

    return () => intervel && clearInterval(intervel);
  }, [
    activeTab,
    me,
    loading,
    autoUpdate,
    selectedOrderStatus,
    getStatusesForTab,
    startDate,
    endDate,
    editSuccess,
  ]);

  const fetchWithDates = (params: any) => {
    const statuses = selectedOrderStatus || getStatusesForTab();
    const userPhone = selectedDriverPhone || selectedClientPhone || undefined;
    const orderId =
      selectedOrderId && selectedOrderId.trim() !== ''
        ? parseInt(selectedOrderId.trim(), 10)
        : undefined;

    setPerPage(params.perPage);
    localStorage.setItem('perPage', params.perPage.toString());
    fetch({
      ...params,
      statuses,
      user_phone: userPhone,
      date_from: startDate ? moment(startDate).format('YYYY-MM-DD') : undefined,
      date_to: endDate ? moment(endDate).format('YYYY-MM-DD') : undefined,
      id: orderId && !Number.isNaN(orderId) ? orderId : undefined,
    });
  };

  const handleResetFilters = useCallback(() => {
    setSelectedOrderId('');
    setSelectedOrderStatus('');
    setSelectedDriverPhone(null);
    setSelectedClientPhone(null);
    setSelectedDriverUser({} as IUser);
    setSelectedClientUser({} as IUser);
    setDriverSearchUsers([]);
    setClientSearchUsers([]);
    setDriverSearchUsersFromApi([]);
    setClientSearchUsersFromApi([]);
    setStartDate(getYesterday());
    setEndDate(getTomorrow());
    setAutoUpdate(false);
    localStorage.setItem('autoUpdate', 'false');
  }, [setDriverSearchUsersFromApi, setClientSearchUsersFromApi]);

  useLayoutEffect(() => {
    fetchCompanies({ page: 1, perPage: 1000 });
  }, []);

  const deleteAction = useCallback(() => {
    setAlertOpen(false);
    if (deleteId) {
      const statuses = getStatusesForTab();
      delOrder(deleteId);
    }
  }, [deleteId, page, perPage, delOrder, getStatusesForTab]);

  // const editAction = useCallback(
  //   (item, mode) => {
  //     history.push(`/orders/${item.id}/${mode}`);
  //   },
  //   [history]
  // );

  const selectAction = useCallback(
    (id: number) => {
      setSelectedId(id);
    },
    [setSelectedId]
  );
  useEffect(() => {
    if (delError) {
      enqueueSnackbar(delError, { variant: 'error' });
      setAlertOpen(false);
      clearErrors();
    }
    return () => {
      clearErrors();
    };
  }, [delError, clearErrors, setAlertOpen, enqueueSnackbar]);

  useEffect(() => {
    if (!me) fetchMe();
    return () => {
      clearMe();
    };
  }, []);

  const translates: { [type: string]: string } = {
    formed: intl.formatMessage({ id: 'ORDER.TYPE.CART' }),
    new: intl.formatMessage({ id: 'ORDER.TYPE.NEW' }),
    driver_found: intl.formatMessage({ id: 'ORDER.TYPE.FORMATION' }),
    driver_coming: intl.formatMessage({ id: 'ORDER.TYPE.DELIVERY' }),
    driver_waiting: intl.formatMessage({ id: 'ORDER.TYPE.DRIVER_WAITING' }),
    way: intl.formatMessage({ id: 'ORDER.TYPE.PAYED' }),
    completed: intl.formatMessage({ id: 'ORDER.TYPE.COMPLETED' }),
    canceled: intl.formatMessage({ id: 'ORDER.TYPE.CANCELED' }),
  };
  // const AccordOrderStates = [
  //   { lable: intl.formatMessage({ id: 'ACCORD.TYPE.CANCELED' }), value: '-1' },
  //   { lable: intl.formatMessage({ id: 'ORDER.TYPE.NEW' }), value: '1' },
  //   { lable: intl.formatMessage({ id: 'ACCORD.TYPE.ERROR' }), value: '2' },
  //   { lable: intl.formatMessage({ id: 'ACCORD.TYPE.INPROD' }), value: '3' },
  //   { lable: intl.formatMessage({ id: 'ACCORD.TYPE.SHIPPED' }), value: '4' },
  // ];
  // const translatesAccord: { [type: string]: string } = {
  //   '-1': intl.formatMessage({ id: 'ACCORD.TYPE.CANCELED' }),
  //   '1': intl.formatMessage({ id: 'ORDER.TYPE.NEW' }),
  //   '2': intl.formatMessage({ id: 'ACCORD.TYPE.ERROR' }),
  //   '3': intl.formatMessage({ id: 'ACCORD.TYPE.INPROD' }),
  //   '4': intl.formatMessage({ id: 'ACCORD.TYPE.SHIPPED' }),
  // };
  // const PaymentOrderStates = [
  //   { lable: intl.formatMessage({ id: 'ORDER.PAYMENT.STATUS.PAID' }), value: 'paid' },
  //   { lable: intl.formatMessage({ id: 'ORDER.PAYMENT.STATUS.NOT_PAID' }), value: 'not_paid' },
  // ];
  const selectStyles = {
    container: (provided: any) => ({
      ...provided,
      // marginBottom: 16,
      width: '100%',
    }),
    menu: (provided: any) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: (provided: any) => ({
      ...provided,
      zIndex: 9999,
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderColor: state.isFocused ? '#369ff7' : '',
      backgroundColor: '#f2f2eb',
      border: 'none !important',
      opacity: state.isDisabled ? 0.5 : 1,
      boxShadow: state.isFocused ? '0 0 0 1px #369ff7 !important' : '',
      minHeight: '42px',
      height: '42px',
      width: '100%',
      minWidth: '170px',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#369ff7' : '#fff',
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: '#4c4c4c',
      fontFamily: 'Montserrat',
      fontWeight: 600,
    }),
    placeholder: (provided: any) => ({
      ...provided,
      fontFamily: 'Montserrat',
      fontWeight: 600,
    }),
    dropdownIndicator: (provided: any, state: any) => {
      return {
        ...provided,
        display: state.selectProps.isSearchable ? provided.display : 'none',
      };
    },
  };
  const orderTypes = getOrderTypeWithTranslates(translates, type === ListType.ABANDONED);

  const isBuyer = useMemo(
    () =>
      userRole?.[0] === UserRoles.ROLE_BUYER || userRole?.[0] === UserRoles.ROLE_BUYER_STAFF,
    [userRole]
  );
  // const isVendor = useMemo(() => userRole?.[0] === UserRoles.ROLE_VENDOR, [userRole]);
  // const isAdmin = useMemo(() => userRole?.[0] === UserRoles.ROLE_ADMIN, [userRole]);

  // const handlerShowMessages = useCallback((item: IOrder) => {
  //   setCurrentResponse(item);
  //   setShowModalMessages(true);
  // }, []);

  const closeMessages = useCallback(() => {
    setShowModalMessages(false);
    setCurrentResponse(null);
    clearMessages();
  }, []);

  const orderStatusOptions = useMemo(() => {
    return orderTypes.map(item => ({
      label: item.translate,
      value: item.type,
    }));
  }, [orderTypes]);

  const filteredStatusOptions = useMemo(() => {
    const availableStatuses = getAvailableStatusesForSelect();
    return orderStatusOptions.filter(option => availableStatuses.includes(option.value));
  }, [orderStatusOptions, getAvailableStatusesForSelect]);

  const handleDeleteDialog = useCallback((id: number | undefined) => {
    setDeleteId(id);
    setAlertOpen(true);
  }, []);

  const editAction = useCallback(
    (item: any, mode: string) => {
      navigate(`/orders/${item.id}/${mode}`);
    },
    [navigate]
  );

  // const newChat = useCallback((companyId?: string | number, userId?: string | number) => {
  //   if (companyId) {
  //     createChatFetch({ companyId });
  //   }
  //   createChatFetch({ userId });
  // }, []);

  // const newUserChat = useCallback((userId?: string | number) => {
  //   createChatFetch({ userId });
  // }, []);

  // if (meLoading || loadingCreated) return <Preloader />;
  if (meLoading) return <Preloader />;

  return (
    <>
      {type !== ListType.ABANDONED && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 3,
            justifyContent: 'flex-start',
            borderRadius: '4px',
            backgroundColor: '#fff',
            p: 2,
            flexWrap: 'wrap',
          }}
        >
          {isCreateOrder && (
            <Button
              color='primary'
              variant='contained'
              onClick={() => navigate(`/orders/create`)}
              sx={{ backgroundColor: '#ffce00', color: '#000' }}
            >
              {fm('COMMON.BUTTON.ADD')}
            </Button>
          )}

          <Card
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              px: 2,
              pb: 2,
              flexWrap: 'wrap',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Typography className={classes.label}>
                {intl.formatMessage({ id: 'ORDER.FILTER.ID' })}
              </Typography>
              <TextField
                placeholder={intl.formatMessage({ id: 'ORDER.FILTER.ID.PLACEHOLDER' })}
                value={selectedOrderId}
                onChange={e => setSelectedOrderId(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#f2f2eb',
                    border: 'none',
                    height: '42px',
                    width: '100px',
                    '& fieldset': {
                      border: 'none',
                    },
                    '&:hover fieldset': {
                      border: 'none',
                    },
                    '&.Mui-focused fieldset': {
                      border: '1px solid #369ff7',
                    },
                  },
                }}
                inputProps={{
                  style: {
                    height: '42px',
                    padding: '0 14px',
                    fontFamily: 'Montserrat',
                    fontWeight: 600,
                    color: '#4c4c4c',
                  },
                }}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 2, width: 170 }}>
              <Typography className={classes.label}>
                {intl.formatMessage({ id: 'ORDER.FILTER.DRIVER.PHONE' })}
              </Typography>
              <AutocompleteStaffPhone
                options={driverSearchUsers || []}
                loading={loadingDriverPhone}
                inputValue={selectedDriverUser}
                label=''
                inputClassName={{ width: '100%' }}
                searchStaff={fetchDriverUsers}
                clearUsers={() => {
                  setDriverSearchUsers([]);
                  setDriverSearchUsersFromApi([]);
                  setSelectedDriverPhone(null);
                  setSelectedDriverUser({} as IUser);
                }}
                setSelectedValue={value => {
                  if (value?.phone) {
                    setSelectedDriverPhone(value.phone);
                    setSelectedDriverUser(value);
                  } else {
                    setSelectedDriverPhone(null);
                    setSelectedDriverUser({} as IUser);
                  }
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#f2f2eb',
                    border: 'none',
                    height: '42px',
                    '& fieldset': {
                      border: 'none',
                    },
                    '&:hover fieldset': {
                      border: 'none',
                    },
                    '&.Mui-focused fieldset': {
                      border: '1px solid #369ff7',
                    },
                  },
                }}
                inputProps={{
                  style: {
                    height: '42px',
                    padding: '0 14px',
                    fontFamily: 'Montserrat',
                    fontWeight: 600,
                    color: '#4c4c4c',
                  },
                }}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 2, width: 170 }}>
              <Typography className={classes.label}>
                {intl.formatMessage({ id: 'ORDER.FILTER.CLIENT.PHONE' })}
              </Typography>
              <AutocompleteStaffPhone
                options={clientSearchUsers || []}
                loading={loadingClientPhone}
                inputValue={selectedClientUser}
                label=''
                inputClassName={{ width: '100%' }}
                searchStaff={fetchClientUsers}
                clearUsers={() => {
                  setClientSearchUsers([]);
                  setClientSearchUsersFromApi([]);
                  setSelectedClientPhone(null);
                  setSelectedClientUser({} as IUser);
                }}
                setSelectedValue={value => {
                  if (value?.phone) {
                    setSelectedClientPhone(value.phone);
                    setSelectedClientUser(value);
                  } else {
                    setSelectedClientPhone(null);
                    setSelectedClientUser({} as IUser);
                  }
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#f2f2eb',
                    border: 'none',
                    height: '42px',
                    '& fieldset': {
                      border: 'none',
                    },
                    '&:hover fieldset': {
                      border: 'none',
                    },
                    '&.Mui-focused fieldset': {
                      border: '1px solid #369ff7',
                    },
                  },
                }}
                inputProps={{
                  style: {
                    height: '42px',
                    padding: '0 14px',
                    fontFamily: 'Montserrat',
                    fontWeight: 600,
                    color: '#4c4c4c',
                  },
                }}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 2, width: '140px' }}>
              <Typography className={classes.label}>
                {intl.formatMessage({ id: 'ORDER.FILTER.DATE.FROM' })}
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ru'>
                <DatePicker
                  value={startDate ? dayjs(startDate) : null}
                  onChange={date => {
                    setStartDate(date ? dayjs(date).toDate() : null);
                  }}
                  format='DD.MM.YYYY'
                  sx={{
                    width: '140px',
                    maxWidth: '140px',
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#f2f2eb',
                      border: 'none',
                      height: '42px',
                      width: '140px',
                      maxWidth: '140px',
                      '& fieldset': {
                        border: 'none',
                      },
                      '&:hover fieldset': {
                        border: 'none',
                      },
                      '&.Mui-focused fieldset': {
                        border: '1px solid #369ff7',
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 2, width: '140px' }}>
              <Typography className={classes.label}>
                {intl.formatMessage({ id: 'ORDER.FILTER.DATE.TO' })}
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ru'>
                <DatePicker
                  value={endDate ? dayjs(endDate) : null}
                  onChange={date => {
                    setEndDate(date ? dayjs(date).toDate() : null);
                  }}
                  format='DD.MM.YYYY'
                  sx={{
                    width: '140px',
                    maxWidth: '140px',
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#f2f2eb',
                      border: 'none',
                      height: '42px',
                      width: '140px',
                      maxWidth: '140px',
                      '& fieldset': {
                        border: 'none',
                      },
                      '&:hover fieldset': {
                        border: 'none',
                      },
                      '&.Mui-focused fieldset': {
                        border: '1px solid #369ff7',
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Typography className={classes.label}>
                {intl.formatMessage({ id: 'ORDER.FILTER.TYPE' })}
              </Typography>
              <Select
                placeholder={fm('ORDER.FILTER.PLACEHOLDER')}
                components={{ IndicatorSeparator: () => null }}
                value={
                  selectedOrderStatus
                    ? { label: translates[selectedOrderStatus], value: selectedOrderStatus }
                    : null
                }
                styles={selectStyles}
                onChange={item => {
                  if (item) {
                    setSelectedOrderStatus(item.value);
                  } else {
                    setSelectedOrderStatus('');
                  }
                }}
                options={[defaultType, ...filteredStatusOptions]}
                menuPortalTarget={document.body}
                menuPosition='fixed'
                isClearable
              />
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 9,
                justifyContent: 'center',
                width: 150,
              }}
            >
              <StyledButton
                type='button'
                onClick={handleResetFilters}
                variant='contained'
                color='secondary'
              >
                {intl.formatMessage({ id: 'ORDER.FILTER.RESET' })}
              </StyledButton>
              {activeTab === 'active' && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={autoUpdate}
                      onChange={e => {
                        setAutoUpdate(e.target.checked);
                        localStorage.setItem('autoUpdate', e.target.checked.toString());
                      }}
                      color='primary'
                    />
                  }
                  label={
                    <Typography className={classes.labelCheckbox}>
                      Обновлять автоматически
                    </Typography>
                  }
                />
              )}
            </div>

            {/* <div style={{display: 'flex', flexDirection: 'column', gap: 2}}>
              <Typography className={classes.label}>
                {intl.formatMessage({
                  id: 'ORDER.FILTER.TYPE',
                })}
              </Typography>

              <Select
                placeholder={fm('ORDER.FILTER.PLACEHOLDER')}
                components={{ IndicatorSeparator: () => null }}
                value={
                  selectedType
                    ? { label: translates[selectedType], value: selectedType }
                    : undefined
                }
                styles={selectStyles}
                onChange={item => {
                  if (item) {
                    setSelectedType(item.value);
                  }
                }}
                options={
                  orderTypes
                    ? [
                        defaultType,
                        ...orderTypes.map(item => ({
                          label: item.translate,
                          value: item.type,
                        })),
                      ]
                    : [defaultType]
                }
            menuPortalTarget={document.body}
            menuPosition="fixed"
              />
          </div> */}
            {/* <Typography className={classes.label}>
                {intl.formatMessage({
                  id: 'ORDER.PAYMENT.STATUS',
                })}
              </Typography>
              <Select
                placeholder={fm('ORDER.FILTER.PLACEHOLDER')}
                components={{ IndicatorSeparator: () => null }}
                value={
                  paymentType
                    ? { label: translatesPayment[paymentType], value: paymentType }
                    : undefined
                }
                styles={selectStyles}
                onChange={item => {
                  if (item) {
                    setPaymentType(item.value);
                  }
                }}
                options={
                  orderTypes
                    ? [
                        defaultType,
                        ...PaymentOrderStates.map(item => ({
                          label: item.lable,
                          value: item.value,
                        })),
                      ]
                    : [defaultType]
                }
              /> */}
            {/* <FilterOrders
                fetchUsers={fetchUsers}
                searchUsers={searchUsers}
                setUsersSearch={setUsersSearch}
                searchUsersLoading={searchLoading}
                fio={fio}
                setFio={setFio}
                setPhone={setPhone}
                startDate={startDate}
                endDate={endDate}
                setStart={setStart}
                setEnd={setEnd}
                loadingPhone={loadingPhone}
                userPhone={userPhone}
                setUserPhone={setUserPhone}
                setEmail={setEmail}
                companySelect={companySelect}
                setCompanySelect={setCompanySelect}
                loadingCompanies={loadingCompanies}
                companies={companies}
                me={me}
          /> */}
          </Card>
        </Box>
      )}
      <div className={classes.container}>
        {/* {type === ListType.FULL && (
          <div className={classes.filterCol}>
            
          </div>
        )} */}
        <div
          className={`${classes.ordersCol} ${type === ListType.ABANDONED ? 'full' : 'full'}`}
        >
          {loading ? (
            <Preloader />
          ) : (
            <>
              {(() => {
                let ordersToShow = orders || [];

                if (selectedDriverPhone) {
                  ordersToShow = ordersToShow.filter(
                    order => order.driver?.phone === selectedDriverPhone
                  );
                }

                if (selectedClientPhone) {
                  ordersToShow = ordersToShow.filter(
                    order => order.user?.phone === selectedClientPhone
                  );
                }

                if (!ordersToShow || !ordersToShow.length) {
                  return (
                    <Typography className={classes.empty} component='h5' variant='h5'>
                      {intl.formatMessage({ id: 'ORDER.CATALOG.LIST.EMPTY' })}
                    </Typography>
                  );
                }

                return (
                  <div className={classes.card}>
                    <Card className={classes.card}>
                      <CardContent className={classes.tableContainer}>
                        <Table aria-label='purchases'>
                          <TableHead>
                            <TableRow>
                              <SHeadTableCell className={classes.cell} align='center'>
                                {intl.formatMessage({ id: 'ORDER.TABLE.ID' })}
                              </SHeadTableCell>
                              <SHeadTableCell className={classes.cell}>
                                {intl.formatMessage({ id: 'ORDER.TABLE.PRODUCT_AMOUNT' })}
                              </SHeadTableCell>
                              <SHeadTableCell className={classes.cell}>
                                {intl.formatMessage({ id: 'ORDER.TABLE.START.LOCATION' })}
                              </SHeadTableCell>
                              <SHeadTableCell className={classes.cell}>
                                {intl.formatMessage({ id: 'ORDER.TABLE.END.LOCATION' })}
                              </SHeadTableCell>
                              <SHeadTableCell className={classes.cell}>
                                {intl.formatMessage({ id: 'COMMENT.ORDER' })}
                              </SHeadTableCell>
                              <SHeadTableCell className={classes.cell}>
                                {intl.formatMessage({ id: 'ORDER.TABLE.SUM_ORDER' })}
                              </SHeadTableCell>
                              <SHeadTableCell className={classes.cell}>
                                {intl.formatMessage({ id: 'ORDER.TABLE.BUYER.INFO' })}
                              </SHeadTableCell>
                              <SHeadTableCell className={classes.cell}>
                                {intl.formatMessage({ id: 'ORDER.TABLE.DRIVER.INFO' })}
                              </SHeadTableCell>
                              <SHeadTableCell className={classes.cell}>
                                {intl.formatMessage({ id: 'ORDER.TABLE.DRIVER.COMMENT' })}
                              </SHeadTableCell>
                              {isCreateOrder && (
                                <SHeadTableCell className={classes.cell}>
                                  {intl.formatMessage({ id: 'SUBMENU.ROLES.OPERATOR' })}
                                </SHeadTableCell>
                              )}
                              <SHeadTableCell align='center' className={classes.cell}>
                                {intl.formatMessage({ id: 'ORDER.TABLE.STATUS' })}
                              </SHeadTableCell>
                              <SHeadTableCell className={classes.cell}>
                                {intl.formatMessage({ id: 'ORDER.TABLE.ACTIONS' })}
                              </SHeadTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {ordersToShow.map((item: IOrderResponse) => (
                              <TableRowOrderList
                                key={item.id.toString()}
                                item={item}
                                me={me}
                                type={type}
                                selectAction={selectAction}
                                handleDeleteDialog={handleDeleteDialog}
                                editAction={editAction}
                                selectedOrderStatuses={[]}
                                selectedId={selectedId}
                                isBuyer={isBuyer}
                                translates={translates}
                                editStatus={editStatus}
                                page={page}
                                perPage={perPage}
                                userId={userId}
                                orderTypes={orderTypes}
                                isCreateOrder={Boolean(isCreateOrder)}
                              />
                            ))}
                          </TableBody>
                          <TableFooter>
                            <TableRow>
                              <TablePaginator
                                statuses={getStatusesForTab()}
                                page={page}
                                realPerPage={orders?.length || 0}
                                total={total}
                                perPage={perPage}
                                fetchRows={fetchWithDates}
                                label={intl.formatMessage({ id: 'ORDER.TABLE.PERPAGE' })}
                              />
                            </TableRow>
                          </TableFooter>
                        </Table>
                      </CardContent>
                    </Card>
                  </div>
                );
              })()}
            </>
          )}
        </div>
      </div>
      {showModalMessages && (
        <MessagesDialog
          open={showModalMessages}
          handleClose={closeMessages}
          currentResponse={currentResponse}
        />
      )}
      <AlertDialog
        open={isAlertOpen}
        message={intl.formatMessage({ id: 'ORDER.DELETE.TEXT' })}
        okText={intl.formatMessage({ id: 'CATEGORIES.DELETE.OK' })}
        cancelText={intl.formatMessage({ id: 'CATEGORIES.DELETE.CANCEL' })}
        handleClose={() => {
          clearErrors();
          setAlertOpen(false);
        }}
        handleAgree={() => deleteAction()}
      />
    </>
  );
};

const connector = connect(
  (state: IAppState) => ({
    meLoading: state.profile.loading,
    orders: state.orders.orders,
    loading: state.orders.loading,
    page: state.orders.page,
    perPage: state.orders.per_page,
    total: state.orders.total,
    delError: state.orders.delError,
    userRole: state.auth.user?.roles,
    me: state.profile.me,

    companies: state.companies.companies,
    loadingCompanies: state.companies.loading,
  }),
  {
    fetch: orderActions.fetchRequest,
    delOrder: orderActions.delRequest,
    clearErrors: orderActions.clearEdit,
    editStatus: orderActions.editStatusRequest,

    clearMessages: messsageActions.clear,

    fetchMe: profileActions.fetchRequest,
    clearMe: profileActions.clearMe,
    fetchCompanies: companiesActions.fetchRequest,
  }
);

type TPropsFromRedux = ConnectedProps<typeof connector>;

export default connector(OrdersList);
